import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.91 8.727a4.09 4.09 0 1 1 8.18 0 4.09 4.09 0 0 1-8.18 0M12 6.273a2.454 2.454 0 1 0 0 4.909 2.454 2.454 0 0 0 0-4.91Z",
  "clip-rule": "evenodd"
}, null, -1), r = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.273 12C.273 5.523 5.523.273 12 .273S23.727 5.523 23.727 12 18.477 23.727 12 23.727C5.524 23.727.273 18.477.273 12M12 1.91a10.09 10.09 0 0 0-7.154 17.206c.196-1.061.584-2.062 1.36-2.867 1.161-1.204 3.017-1.794 5.794-1.794 2.778 0 4.633.59 5.794 1.794.777.805 1.163 1.806 1.36 2.868A10.09 10.09 0 0 0 12 1.91m5.666 18.44c-.11-1.321-.398-2.29-1.049-2.965-.71-.735-2.022-1.294-4.617-1.294s-3.907.56-4.617 1.294c-.65.676-.938 1.644-1.049 2.967A10.04 10.04 0 0 0 12 22.091a10.04 10.04 0 0 0 5.666-1.74Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  n,
  r
];
function d(i, s) {
  return l(), o("svg", t, [...c]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
